import enumeration from "./enumeration";

const PaymentMethod = {
  Credit: "CREDIT",
  Cash: "CASH",
  CreditDebit: "CREDIT_DEBIT",
  PouchPay: "POUCHPAY",
  Others: "OTHER",
};

export default enumeration(PaymentMethod);
